module.exports = __webpack_public_path__ + "img/image 004.a0827f14.png";